var render = function render(_c, _vm) {
  return _c(
    "section",
    { attrs: { id: "faqs" } },
    [
      _c(
        "wa-question-and-answer",
        { attrs: { id: "about", title: "What is Font Awesome?" } },
        [
          _c("template", { slot: "copy" }, [
            _c(
              "p",
              [
                _vm._v(
                  "\n        Font Awesome is the company home of\n        "
                ),
                _c("site-link", { attrs: { to: _vm.parent.$icons() } }, [
                  _vm._v("Font Awesome Icons"),
                ]),
                _vm._v(
                  ", libraries of free-to-use and paid icons. As a company, Font Awesome publishes icons\n        on its website, "
                ),
                _c("site-link", { attrs: { to: { name: "home" } } }, [
                  _vm._v("fontawesome.com"),
                ]),
                _vm._v(", as well through\n        "),
                _c("site-link", { attrs: { to: { hash: "#cdns" } } }, [
                  _vm._v("content delivery networks"),
                ]),
                _vm._v("\n        for use on customers' websites.\n      "),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Font Awesome sets only its own privacy policy, not the privacy policies of Font Awesome customers, affiliates, or others who use Font Awesome icons.\n        You should ask all of those involved in administering and hosting websites that you use for their privacy policies.\n      "
              ),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "wa-question-and-answer",
        {
          attrs: {
            id: "collection",
            title: "How does Font Awesome collect data about me?",
          },
        },
        [
          _c("template", { slot: "copy" }, [
            _c("p", [_vm._v("Font Awesome collects data about you:")]),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "fa-ul",
                staticStyle: {
                  "--fa-li-width": "3em",
                  "--margin-bottom": "var(--spacing-2xl)",
                  "--margin-top": "var(--spacing-2xl)",
                },
              },
              [
                _c(
                  "li",
                  { staticClass: "margin-bottom-md" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faTelescope,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v("\n          when you browse\n          "),
                    _c("site-link", { attrs: { to: { name: "home" } } }, [
                      _vm._v("fontawesome.com"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "margin-bottom-md" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faGlobe,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n          when you use Font Awesome's\n          "
                    ),
                    _c("site-link", { attrs: { to: { hash: "#cdns" } } }, [
                      _vm._v("content delivery networks"),
                    ]),
                    _vm._v(", or visit websites that do\n        "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "margin-bottom-md" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faUser,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n          when you create and use an account on\n          "
                    ),
                    _c("site-link", { attrs: { to: { name: "home" } } }, [
                      _vm._v("fontawesome.com"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "margin-bottom-md" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faBagShopping,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n          when you buy products and services from Font Awesome through the\n          "
                    ),
                    _c("site-link", { attrs: { to: { name: "home" } } }, [
                      _vm._v("fontawesome.com"),
                    ]),
                    _vm._v("\n          web store\n        "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "margin-bottom-md" }, [
                  _c(
                    "span",
                    {
                      staticClass: "fa-li",
                      staticStyle: { color: "var(--fa-gravy)" },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.parent.$v6.regular.faEnvelopeOpenText,
                          size: "lg",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n          when you contact Font Awesome by e-mail for support or other help\n        "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Font Awesome does not buy or otherwise receive data about you from data brokers."
              ),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "wa-question-and-answer",
        {
          attrs: {
            id: "data",
            title: "What data does Font Awesome collect about me, and why?",
          },
        },
        [
          _c("template", { slot: "copy" }, [
            _c("div", { attrs: { id: "visit-data" } }, [
              _c("h4", { staticClass: "h5 margin-top-2xl" }, [
                _vm._v(
                  "Font Awesome collects data about visits to fontawesome.com."
                ),
              ]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _vm._v("\n          When you visit\n          "),
                  _c("site-link", { attrs: { to: { name: "home" } } }, [
                    _vm._v("fontawesome.com"),
                  ]),
                  _vm._v(
                    ", whether you have an account or not, the site uses cookies, server logs, and other\n          methods to collect data about what pages you visit and when.\n        "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Font Awesome uses data about how you use the website to:"
                ),
              ]),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "fa-ul",
                  staticStyle: {
                    "--fa-li-width": "3em",
                    "--margin-bottom": "var(--spacing-2xl)",
                    "--margin-top": "var(--spacing-2xl)",
                  },
                },
                [
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faGaugeMax,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            optimize the website, so it's quick and easy to use\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faBanBug,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            diagnose and debug technical errors\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faShield,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            defend the website from abuse and technical attacks\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faHandshake,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            associate your browsing session with an affiliate, if you click throug h an affiliate's referral link\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faBagShopping,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            associate your account with an affiliate, if you buy after clicking thr ough an affiliate's referral link\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faBoxBallot,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            compile statistics on icon popularity\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faEnvelopeOpenText,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            compile statistics on the kinds of software and computers visitors use\n          "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Font Awesome usually stores data about how you use the forum in identifiable form for just a few weeks. In special circumstances, like extended\n          investigations about technical attacks, Font Awesome may preserve log data longer, for analysis. Font Awesome stores aggregate statistics about use\n          of the website indefinitely, but those statistics don't include data identifiable to you personally.\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { attrs: { id: "cdns" } }, [
              _c("h4", { staticClass: "h5 margin-top-2xl" }, [
                _vm._v(
                  "Font Awesome collects data about use of its content delivery networks."
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Content delivery networks are worldwide networks of computer servers that make sure everyone online can download files quickly from servers near to\n          them. Font Awesome uses content delivery networks to serve files for its free and Pro/Pro+ icons. Many websites using Font Awesome\n          icons have visitors download the icons from Font Awesome's content delivery networks.\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          When you visit a website that uses a Font Awesome content delivery network to load icons, Font Awesome collects data about what icon files you\n          download and when.\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Font Awesome uses data about how you use Font Awesome content delivery networks to:"
                ),
              ]),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "fa-ul",
                  staticStyle: {
                    "--fa-li-width": "3em",
                    "--margin-bottom": "var(--spacing-2xl)",
                    "--margin-top": "var(--spacing-2xl)",
                  },
                },
                [
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faGaugeMax,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            optimize the content delivery networks, so website visitors can down load files quickly\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faBanBug,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            diagnose and debug technical errors\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faShield,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            defend the content delivery networks from abuse and technical attacks\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faCalculator,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            calculate fees for Font Awesome Pro customers\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faBoxBallot,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            compile statistics on icon popularity\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faComputerClassic,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            compile statistics on the kinds of software and computers visitors use\n          "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Font Awesome usually stores data about how you use content delivery networks in identifiable form for just a few weeks. In special circumstances,\n          like extended investigations about technical attacks, Font Awesome may preserve log data longer, for analysis. Font Awesome stores aggregate\n          statistics about use of content delivery networks indefinitely, but those statistics don't include data identifiable to you personally.\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { attrs: { id: "account-data" } }, [
              _c("h4", { staticClass: "h5 margin-top-2xl" }, [
                _vm._v("Font Awesome collects account data."),
              ]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _vm._v("\n          To buy\n          "),
                  _c("site-link", { attrs: { to: { name: "plans" } } }, [
                    _vm._v("Font Awesome Pro"),
                    _vm.parent.$releases.active.versionParts.major > 6
                      ? _c("span", [_vm._v("/Pro+")])
                      : _vm._e(),
                  ]),
                  _vm._v(
                    ", access Pro files, and configure Pro services like "
                  ),
                  _c("site-link", { attrs: { to: { hash: "#cdns" } } }, [
                    _vm._v("content delivery networks"),
                  ]),
                  _vm._v(", you need a\n          "),
                  _c("site-link", { attrs: { to: { name: "home" } } }, [
                    _vm._v("fontawesome.com"),
                  ]),
                  _vm._v(
                    "\n          account. To sign up for an account, Font Awesome requires your e-mail address, you may optionally provide your name, your company's name and other\n          preference data.\n        "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                [
                  _vm._v(
                    "\n          Font Awesome uses your account data to identify you on\n          "
                  ),
                  _c("site-link", { attrs: { to: { name: "home" } } }, [
                    _vm._v("fontawesome.com"),
                  ]),
                  _vm._v(".\n        "),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", [_vm._v("Font Awesome uses your e-mail address to:")]),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "fa-ul",
                  staticStyle: {
                    "--fa-li-width": "3em",
                    "--margin-bottom": "var(--spacing-2xl)",
                    "--margin-top": "var(--spacing-2xl)",
                  },
                },
                [
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faPartyHorn,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            announce new versions of Pro/Pro+ icons, software, and services\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faBullseyeArrow,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            advertise new Font Awesome products and services\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faBullhorn,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            send you alerts about Pro services\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faKeySkeleton,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            reset your password and help keep your account secure\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faMessageExclamation,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            contact you in special circumstances related to your account\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "margin-bottom-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "fa-li",
                        staticStyle: { color: "var(--fa-gravy)" },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.parent.$v6.regular.faScaleBalanced,
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n            contact you about legal requests\n          "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Font Awesome stores your account data as long as your account remains open."
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "lh-copy", attrs: { id: "payment-data" } },
              [
                _c("h4", { staticClass: "h5 margin-top-2xl" }, [
                  _vm._v("Font Awesome collects payment card data."),
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _vm._v(
                      "\n          To buy licenses and sign up for\n          "
                    ),
                    _c("site-link", { attrs: { to: { name: "plans" } } }, [
                      _vm._v("Font Awesome Pro"),
                      _vm.parent.$releases.active.versionParts.major > 6
                        ? _c("span", [_vm._v("/Pro+")])
                        : _vm._e(),
                    ]),
                    _vm._v(
                      ", Font Awesome requires your payment card data. Font Awesome does not collect or store enough information to charge your card itself. Rather, Font\n          Awesome's\n          "
                    ),
                    _c(
                      "site-link",
                      { attrs: { to: { hash: "#payment-processors" } } },
                      [_vm._v("payment processors")]
                    ),
                    _vm._v(
                      "\n          collect that data on Font Awesome's behalf, and gives Font Awesome security tokens that allow Font Awesome to create charges and subscriptions.\n        "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          Font Awesome uses your payment card data only to charge for Font Awesome products and services. Font Awesome instructs its payment processors to\n          store your payment card data only as long as you use paid Font Awesome services.\n        "
                  ),
                ]),
              ]
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "wa-question-and-answer",
        {
          attrs: {
            id: "choice",
            title: "How can I make choices about data collection?",
          },
        },
        [
          _c("template", { slot: "copy" }, [
            _c(
              "p",
              [
                _vm._v("\n        You're free to visit\n        "),
                _c("site-link", { attrs: { to: { name: "home" } } }, [
                  _vm._v("fontawesome.com"),
                ]),
                _vm._v(
                  "\n        without logging in. You may also configure your web browser to disable cookies when visiting the website.\n      "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                'You can set your cookie preferences by clicking the "Cookie Preferences" link located in the footer of all pages.'
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        You can opt out of Google Analytics using a\n        "
              ),
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href: "https://tools.google.com/dlpage/gaoptout",
                  },
                },
                [_vm._v("\n          browser extension ")]
              ),
              _vm._v(".\n      "),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Font Awesome does not respond to the\n        "
              ),
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href: "https://en.wikipedia.org/wiki/Do_Not_Track",
                  },
                },
                [_vm._v("\n          Do Not Track HTTP header ")]
              ),
              _vm._v(".\n      "),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "wa-question-and-answer",
        {
          attrs: {
            id: "locality",
            title: "Where does Font Awesome store data about me?",
          },
        },
        [
          _c("template", { slot: "copy" }, [
            _c("p", [
              _vm._v(
                "Font Awesome stores account data, data about website use, and data about content delivery network use on servers in the United States of America."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Content delivery network servers are located worldwide, and store data about their use wherever they are located."
              ),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "wa-question-and-answer",
        {
          attrs: {
            id: "gdpr",
            title:
              "Does Font Awesome comply with the EU General Data Protection Regulation?",
          },
        },
        [
          _vm._v("\n    Font Awesome respects privacy rights under\n    "),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: "http://eur-lex.europa.eu/legal-content/EN/TXT/?uri=uriserv:OJ.L_.2016.119.01.0001.01.ENG",
              },
            },
            [_vm._v("\n      Regulation (EU) 2016/679 ")]
          ),
          _vm._v(
            ", the European Union's General Data Protection Regulation (GDPR). Information that GDPR requires Font Awesome to give can be found throughout these\n    questions and answers.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "wa-question-and-answer",
        {
          attrs: {
            id: "international-transfer",
            title:
              "How is Font Awesome in Compliance with GDPR if my Data is Transferred Internationally?",
          },
        },
        [
          _c("p", [
            _vm._v(
              "International transfers are allowed via the adequacy decision associated with the EU-U.S. Data Protection Framework."
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "wa-question-and-answer",
        {
          attrs: {
            id: "access",
            title: "Where can I see, change, and erase data about me?",
          },
        },
        [
          _c("template", { slot: "copy" }, [
            _c(
              "p",
              [
                _vm._v(
                  "\n        You can see and change your account data at any time by visiting your account page on\n        "
                ),
                _c("site-link", { attrs: { to: { name: "home" } } }, [
                  _vm._v("fontawesome.com"),
                ]),
                _vm._v(".\n      "),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v(
                  "\n        You can download a copy of all the data Font Awesome currently has about you\n        "
                ),
                _c(
                  "site-link",
                  { attrs: { to: { name: "account.settings" } } },
                  [_vm._v("here")]
                ),
                _vm._v(" (requires login).\n      "),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("\n        You can cancel your\n        "),
                _c("site-link", { attrs: { to: { name: "plans" } } }, [
                  _vm._v("Font Awesome Pro"),
                ]),
                _vm._v(
                  "\n        subscription at any time. Canceling subscription will also start the process of deleting your account data.\n      "
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "wa-question-and-answer",
        {
          attrs: {
            id: "share",
            title: "Does Font Awesome share data about me with others?",
          },
        },
        [
          _c("template", { slot: "copy" }, [
            _c(
              "p",
              [
                _vm._v(
                  "\n        Font Awesome does not sell or give information about you to other companies or services. However, Font Awesome does use services from other companies\n        to provide\n        "
                ),
                _c("site-link", { attrs: { to: { name: "home" } } }, [
                  _vm._v("fontawesome.com"),
                ]),
                _vm._v(", "),
                _c("site-link", { attrs: { to: { hash: "#cdns" } } }, [
                  _vm._v("content delivery networks"),
                ]),
                _vm._v(
                  ", and to\n        distribute and develop icons and software. The companies behind those services may collect data about you on their own, for their own purposes. Some\n        of these services may be used to collect information about your online activities across different websites. All of these services are based in the\n        United States.\n      "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Affiliates are companies or individuals who recommend Font Awesome and refer customers through links that enable us to pay them a sales commission. We\n        do not share any personally identifiable data about you with affiliates, even if you purchase Font Awesome through an affiliate's link. We provide\n        affiliates with summary reports of sales and commissions, and a detail report that shows time-stamped log entries of when sales occur.\n      "
              ),
            ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }